<mat-tab-group
  [hidden]="!tabs || tabs.length <= 1"
  [selectedIndex]="initialIndex"
  (selectedIndexChange)="navigate($event)">
  @for (tab of tabs; track tab) {
    <mat-tab (click)="navigateToTab(tab)">
      <ng-template mat-tab-label>
        <span>{{ tab.tableView.title }}</span
        >&nbsp;
        @if (tabsWithCount) {
          <span>({{ tabsWithCount[tab.tableView.code] }})</span>
        }
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
